import { render } from "./IndexSupplierPage.vue?vue&type=template&id=1928b251"
import script from "./IndexSupplierPage.vue?vue&type=script&lang=js"
export * from "./IndexSupplierPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__